export enum GeneralMutationTypes {
  SET_USER_HIERARCHY = 'SET_USER_HIERARCHY',
  SET_META_DATA = 'SET_META_DATA',
  SET_ETL_DATA = 'SET_ETL_DATA',
  SET_SHOW_SESSION_MODAL = 'SET_SHOW_SESSION_MODAL',
  SET_USER_PREFERENCES = 'SET_USER_PREFERENCES',
  SET_CLIENT_NAME_RESOLUTION_MAP = 'SET_CLIENT_NAME_RESOLUTION_MAP',
  SET_CLIENT_NAME_RESOLUTION_LOADING = 'SET_CLIENT_NAME_RESOLUTION_LOADING',
  SET_CONTAINER_NAME_RESOLUTION_MAP = 'SET_CONTAINER_NAME_RESOLUTION_MAP',
  SET_CONTAINER_NAME_RESOLUTION_LOADING = 'SET_CONTAINER_NAME_RESOLUTION_LOADING',
  SET_COLLECTION_NAME_RESOLUTION_MAP = 'SET_COLLECTION_NAME_RESOLUTION_MAP',
  SET_COLLECTION_NAME_RESOLUTION_LOADING = 'SET_COLLECTION_NAME_RESOLUTION_LOADING',
  SET_LEAD_DATA_RESOLUTION_MAP = 'SET_LEAD_DATA_RESOLUTION_MAP',
  SET_LEAD_DATA_RESOLUTION_LOADING = 'SET_LEAD_DATA_RESOLUTION_LOADING',
  SET_BANKER_NAME_RESOLUTION_MAP = 'SET_BANKER_NAME_RESOLUTION_MAP',
  SET_BANKER_NAME_RESOLUTION_LOADING = 'SET_BANKER_NAME_RESOLUTION_LOADING',
  RESET_COLLECTION_CONTAINER_NAME_RESOLUTION = 'RESET_COLLECTION_CONTAINER_NAME_RESOLUTION',
}
